<template>
  <div>
    <div class="seth-set bg-primary px-6 py-10">
      <p
        class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
        @click="handleBack"
      >
        <feather-icon class="flex" icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
        Go Back
      </p>
      <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
        User Role
      </h2>
    </div>

    <div class="bg-white p-8 fixed-top flex justify-center items-center">
      <div class="w-full mx-auto">
        <!-- <el-Input
          placeholder=""
          v-model="input"
          class="w-full"
          type="text"
          
        /> -->
        <div class="bg-white relative flex items-center w-full mx-auto mt-4">
          <div class="pr-4 relative w-full">
            <el-input
              placeholder="Search"
              v-model="inputSearch"
              @onchange="inputSearch"
              class="w-full"
              maxlength="50"
            ></el-input>
            <div
              class="absolute top-0 mr-2 mt-2 bg-white cursor-pointer right-16px"
            >
              <feather-icon icon="SearchIcon" SvgClasses="w-4 h-4" />
            </div>
          </div>
          <el-button
            @click="emailPopup = true"
            type="primary"
            class="rounded-lg cust-elprimary"
            >Add Role</el-button
          >
        </div>

        <el-dialog
          class="cust-header"
          width="30%"
          title="Add Role"
          :visible.sync="emailPopup"
        >
          <div class="w-full mx-auto">
            <label for="" class="">Role Name</label>
            <el-input
              placeholder="Please input"
              class="w-full mt-3"
              v-model="input"
            ></el-input>
            <vs-button
              color="primary"
              class="w-full mt-10 border-0 font-semibold lg:py-3 fsize14 md:py-3 py-2 px-10 sm-fsize14"
              @click="
                () => {
                  if (update === false) {
                    createWebsiteRole();
                  } else {
                    updateWebsiteRole();
                  }
                }
              "
            >
              Submit
            </vs-button>
          </div>
        </el-dialog>
        <div class="w-full mb-8">
          <el-table
            :data="websiteRole"
            border
            style="width: 100%"
            class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
            header-row-class-name="thead-light table-th-colorpd"
          >
            <el-table-column
              :index="indexmethod"
              type="index"
              label="Sr.no"
              width="80"
            ></el-table-column>
            <el-table-column prop="name" label="Role Name">
              <template v-slot="{ row }">
                <P class="text-gray">{{ row.websiteRole }}</P>
              </template>
            </el-table-column>

            <el-table-column prop="createdAt" label="Created Date">
              <template v-slot="{ row }">
                <P class="text-gray">{{ getDate(row.createdAt) }}</P>
              </template>
            </el-table-column>

            <el-table-column
              label="Actions"
              width="200"
              prop="action"
              class-name="text-center"
            >
              <template v-slot="{ row }">
                <div class="flex justify-center gap-2">
                  <feather-icon
                    icon="EditIcon"
                    @click="editGetData(row)"
                    svgClasses="w-4 h-4"
                    class="cursor-pointer"
                  />
                  <feather-icon
                    @click="deleteData(row)"
                    icon="Trash2Icon"
                    svgClasses="w-4 h-4"
                    class="cursor-pointer text-danger"
                  />
                </div>
              </template>
            </el-table-column>
          </el-table>
          <!-- <div class="w-full flex justify-end mt-6">
            <el-pagination
              background
              layout="prev, pager, next"
              @current-change="
                (value) => {
                  currentPage = value;
                  getData();
                }
              "
              :page-size="10"
              :total="count"
            >
            </el-pagination>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const debounce = function debounce(func, wait = 800) {
  let debounceTimer;
  return function (...args) {
    if (debounceTimer) clearTimeout(debounceTimer);
    const context = this;
    debounceTimer = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  };
};
import moment from "moment";
export default {
  data() {
    return {
      input: "",
      inputSearch: "",
      currentPage: 1,
      emailPopup: false,
      websiteRole: [],
      editData: "",
      update: false,
    };
  },
  methods: {
    getDate(createdAt) {
      return moment(createdAt).format(" Do MMMM YYYY");
    },

    async getWebsitePayload() {
      let payload = {};
      if (this.inputSearch) {
        Object.assign(payload, { search: this.inputSearch });
      }
      let data = await this.$store.dispatch(
        "WebsitePayload/getWebsitePayload",
        payload
      );
      this.websiteRole = data.data;
    },
    async updateWebsiteRole() {
      let payload = {
        _id: this.editData._id,
        websiteRole: this.input,
      };
      let data = await this.$store.dispatch(
        "WebsitePayload/updateWebsitePayload",
        payload
      );
      if (data.code === 200) {
        this.$swal({
          text: "Role Successfully Updated",
          icon: "success",
          confirmButtonColor: "#830c81",
          // cancelButtonColor: "#d33",
          confirmButtonText: "Okay",
        });
        this.getWebsitePayload();
        this.emailPopup = false;
      }
    },
    async deleteData(dataDe) {
      this.$swal({
        title: "Are you sure?",
        icon: "info",
        type: "Warning",
        showCancelButton: true,
        confirmButtonColor: "#cd3197",
        confirmButtonText: "Yes, Delete it",
        cancelButtonText: "No, keep it",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then(async (result) => {
        if (result.value) {
          let payload = {
            _id: dataDe._id,
          };
          let data = await this.$store.dispatch(
            "WebsitePayload/deleteWebsitePayload",
            payload
          );
          if (data.code === 200) {
            this.$swal({
              text: "Role Successfully Deleted",
              icon: "success",
              confirmButtonColor: "#830c81",
              // cancelButtonColor: "#d33",
              confirmButtonText: "Okay",
            });
            this.getWebsitePayload();
            this.emailPopup = false;
          }
        }
      });
    },
    editGetData(data) {
      this.update = true;
      this.emailPopup = true;
      this.editData = data;
      this.input = this.editData.websiteRole;
    },
    async createWebsiteRole() {
      let payload = {
        websiteRole: this.input,
      };
      let data = await this.$store.dispatch(
        "WebsitePayload/createWebsitePayload",
        payload
      );
      if (data.code === 200) {
        this.$swal({
          text: "Role Successfully Created",
          icon: "success",
          confirmButtonColor: "#830c81",
          // cancelButtonColor: "#d33",
          confirmButtonText: "Okay",
        });
        this.getWebsitePayload();
        this.emailPopup = false;
      }
    },
  },
  watch: {
    emailPopup(value) {
      if (value === false) {
        this.input = "";
      }
    },
    inputSearch: debounce(async function (value) {
      this.getWebsitePayload();
    }),
  },
  async mounted() {
    await this.getWebsitePayload();
  },
};
</script>
